import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { TabView, TabPanel } from 'primereact/tabview';
import { menuIdData } from "../../utils/Constants";
import { get_user_menu_permission, getCookie } from "../../utils/CommonFunctions";
import axios from "axios";
import { Modal, Button, Table } from "react-bootstrap";
import Settings from "ATSComponents/Admin_Module/Settings";
const AdminDasboardats = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [settingsViewPermission, setSettingsViewPermission] = useState(false);
  const [userViewPermission, setUserViewPermission] = useState(false);
  const [lookupViewPermission, setLookupViewPermission] = useState(false);
  const [permissionsLoaded, setPermissionsLoaded] = useState(false);
  const [settingsMenuId, setSettingsMenuId] = useState(menuIdData.Settings);
  useEffect(() => {
    let active = true;
    axios.get('/api/v1/get-menu-data/').then(({ data }) => {
      const settingsMenu = (data.results || []).flatMap(menu => menu.sub_menus || [])
        .find(menu => String(menu.menu_name || '').trim().toLowerCase() === 'settings');
      if (active && settingsMenu?.menu_id != null) setSettingsMenuId(settingsMenu.menu_id);
    }).catch(error => console.error('Unable to resolve Settings menu', error));
    return () => { active = false; };
  }, []);
  const [organizations, setOrganizations] = useState([]);
  const [connecting, setConnecting] = useState(false);
  const userInfos = JSON.parse(sessionStorage.getItem("user-info"));
  const [isLinkedInConnected, setIsLinkedInConnected] = useState(false);

  const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
    const [companyId, setCompanyId] = useState(intialcompanyId);
    const [showOrgModal, setShowOrgModal] = useState(false);

const handleCloseOrgModal = () => {
  setShowOrgModal(false);
};
  useEffect(() => {
    const refreshPermissions = () => {
    const menu_id = settingsMenuId;
    let assignedModules = [];
    try {
      assignedModules = JSON.parse(getCookie('childModules') || '[]');
    } catch {
      assignedModules = [];
    }
    setSettingsViewPermission(get_user_menu_permission(menu_id, 'view') ||
      (Array.isArray(assignedModules) && assignedModules.some(id => Number(id) === Number(menu_id))));
    
    // const menu_idUSER = menuIdData?.Settings;
    // setSettingsViewPermission(get_user_menu_permission(menu_idUSER, 'view'));

    const menu_idlookup = menuIdData?.LookupCustomization ;
    setLookupViewPermission(get_user_menu_permission(menu_idlookup, 'view'));
    setPermissionsLoaded(true);
    };
    refreshPermissions();
    window.addEventListener('user-menu-permissions-updated', refreshPermissions);
    return () => window.removeEventListener('user-menu-permissions-updated', refreshPermissions);
  }, [settingsMenuId]);

  const allTabRoutes = [
    { label: "User Management", route: "/usermanagment" },
    { label: "Settings", route: "/settings",restricted: true },
    { label: "Lookup Customization", route: "/lookup_Cus",restricted:true },
    { label: "My Account", route: "/myAccount" },
    { label: "Social Media", route: "/socialMedia" }
  ];

  // Filter based on permission
  const filteredTabs = allTabRoutes.filter(tab => {
    if (tab.restricted && tab.label === 'Settings') {
      return settingsViewPermission;
    }
    if (tab.restricted && tab.label === 'Lookup Customization') {
      return lookupViewPermission;
    }
    return true;
  });
  const selectedTabParam = new URLSearchParams(location.search).get("selectedTab");
  const requestedTab = selectedTabParam !== null ? allTabRoutes[Number(selectedTabParam)] : null;
  useEffect(() => {
    if (!permissionsLoaded || location.pathname !== "/admin-dashboard" || !requestedTab || requestedTab.label === "Settings") return;
    if (filteredTabs.some(tab => tab.route === requestedTab.route)) {
      navigate(requestedTab.route, { replace: true });
    }
  }, [permissionsLoaded, location.pathname, selectedTabParam, settingsViewPermission, lookupViewPermission, navigate]);

const [redirectUri, setRedirectUri] = useState("");
useEffect(() => {
  const fetchRedirectUri = async () => {
    try {
      const response = await axios.get(
        "/api/v1/linkedin-redirect-uri/",
       
      );

      // console.info("✅ Redirect URI API response:", response.data);
      setRedirectUri(response.data?.redirect_uri);
    } catch (error) {
      console.error(
        "❌ Failed to fetch redirect URI:",
        error.response?.data || error
      );
    }
  };

  fetchRedirectUri();
}, []);

  /* ================== LINKEDIN LOGIN ================== */
  const handleLinkedInConnect = () => {
    const CLIENT_ID = "86id580vkwjmta";
    // const REDIRECT_URI = "https://atsqa.bharatpayroll.com/";
    const SCOPE = [
      "w_member_social",
      "email",
      "profile",
      "openid",
      "r_ads_reporting",
      "r_organization_social",
      "rw_organization_admin",
      "w_organization_social",
      "rw_ads",
      "r_basicprofile",
      "r_organization_admin",
      "r_1st_connections_size"
    ].join(" ");

    const oauthUrl =
      `https://www.linkedin.com/oauth/v2/authorization?` +
      `response_type=code&client_id=${CLIENT_ID}` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}&state=sdfghjkvbnmvb` +
      `&scope=${encodeURIComponent(SCOPE)}`;

    console.log("🔗 LinkedIn OAuth URL:", oauthUrl);

    window.location.href = oauthUrl;
  };

  /* ================== EXCHANGE CODE → TOKEN → FETCH ORGS ================== */
  // const exchangeCodeForToken = async (code) => {
  //   try {
  //     setConnecting(true);

  //     // Exchange code → token
  //     const res = await tokenLinkedInSetting({ code, redirect_uri: REDIRECT_URI });
  //     if (res?.data?.error_code !== 200) {
  //       triggerAlert("error", "", "LinkedIn login failed");
  //       return;
  //     }

  //     // Fetch token from credentials API
  //     const credRes = await fetchLinkedInSetting();
  //     if (credRes?.data?.error_code !== 200) {
  //       triggerAlert("error", "", "Failed to fetch LinkedIn token");
  //       return;
  //     }

  //     const token = credRes.data.results.linkedin_access_token;
  //     setLinkedInToken(token);

  //     // Fetch organizations using token
  //     const orgRes = await fetchLinkedInOrganizations({ access_token: token });
  //     if (orgRes?.data?.error_code === 200) {
  //       setOrganizations(orgRes.data.results || []);
  //       setShowOrgModal(true);
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     triggerAlert("error", "", "Token exchange failed");
  //   } finally {
  //     setConnecting(false);
  //     window.history.replaceState({}, document.title, window.location.pathname);
  //   }
  // };


  /* ================== READ CODE FROM URL ================== */
useEffect(() => {
  const savedCode = localStorage.getItem("linkedin_oauth_code");
  const savedUrl = localStorage.getItem("linkedin_oauth_url");

  console.log("✅ Stored LinkedIn Code:", savedCode);
  console.log("✅ Stored LinkedIn URL:", savedUrl);
}, []);




  /* ================== CONNECT ORGANIZATION ================== */
  // const handleConnectOrganization = async () => {
  //   if (!selectedOrg) return;

  //   const payload = {
  //     linkedin_access_token: linkedInToken,
  //     linkedin_organization: selectedOrg.organization_id
  //   };

  //   try {
  //     setIsSaving(true);
  //     const res = await fetchLinkedInData(payload);

  //     if (res?.data?.error_code === 200) {
  //       triggerAlert("success", "", "LinkedIn connected successfully");

  //       setValue("linkedin_access_token", linkedInToken);
  //       setValue("linkedin_organization", selectedOrg.organization_id);

  //       setShowOrgModal(false);
  //       setSelectedOrg(null);

  //       fetchData();
  //     } else {
  //       triggerAlert("error", "", "Failed to save LinkedIn data");
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     triggerAlert("error", "", "Failed to save LinkedIn settings");
  //   } finally {
  //     setIsSaving(false);
  //   }
  // };

  /* ================== MANUAL SAVE (EDIT MODE) ================== */
  // const handleUpdate = async (data) => {
  //   try {
  //     setIsSaving(true);
  //     const res = await updateLinkedInSettings(data);
  //     if (res?.data?.error_code === 200) {
  //       triggerAlert("success", "", "Updated successfully");
  //       fetchData();
  //       setEditMode(false);
  //     }
  //   } catch {
  //     triggerAlert("error", "", "Something went wrong");
  //   } finally {
  //     setIsSaving(false);
  //   }
  // };

  // const handleCancelEdit = () => {
  //   setEditMode(false);
  //   fetchData();
  // };

  // Auto-select organization if only one is available
  // useEffect(() => {
  //   if (organizations.length === 1) {
  //     setSelectedOrg(organizations[0]);
  //   }
  // }, [organizations]);

  /* ================== TAB HANDLING ================== */
  const handleTabChange = (e) => {
    const index = e.index;
    const tab = filteredTabs[index];
    if (!tab) return;
    navigate(tab.label === "Settings" ? "/admin-dashboard?selectedTab=1" : tab.route);
  };

  const getActiveIndex = () =>
    filteredTabs.findIndex(tab =>
      location.pathname === "/admin-dashboard" && requestedTab
        ? tab.route === requestedTab.route
        : location.pathname.startsWith(tab.route)
    );

  const [activeIndex, setActiveIndex] = useState(getActiveIndex());

  useEffect(() => {
    setActiveIndex(getActiveIndex());
  }, [location.pathname, location.search, settingsViewPermission, lookupViewPermission]);
useEffect(() => {
    const savedCode = localStorage.getItem("linkedin_oauth_code");
    const savedUrl = localStorage.getItem("linkedin_oauth_url");

    if (savedCode) {
        console.log("ADMIN: LinkedIn code from ATS page =", savedCode);
        console.log("ADMIN: URL from ATS page =", savedUrl);

        localStorage.removeItem("linkedin_oauth_code");
        localStorage.removeItem("linkedin_oauth_url");

        exchangeCodeForToken(savedCode);
    } else {
        fetchLinkedInDetails();
    }
}, []);
const sendLinkedInDetails = async (organizations) => {
  try {
    // Transform your API response into the format required
    const linkedin_details = organizations.map(org => ({
      organisation_id: org.organization_id,
      organisation_name: org.organization_name?.localized?.en_US || "Unknown",
      access_token: org.access_token
    }));

    const payload = {
      company_id: companyId,
      linkedin_details
    };

    const { data } = await axios.post(
      "/api/v1/linkedin-details/",
      payload,
      
    );

    console.log("✅ LinkedIn details sent successfully:", data);
  } catch (err) {
    console.error("❌ Failed to send LinkedIn details:", err.response?.data || err);
  }
};

const fetchOrganizationId = async (accessToken) => {
  try {
    const { data } = await axios.post(
      "https://omnichannelapi.vitelglobal.com/linkedin/api/fetch_organization_id/",
      {
        access_token: accessToken
      },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        withCredentials: true
      }
    );

    console.log("🏢 Organization response:", data);

    if (data?.error_code === 200) {
      const organizations = data.results || [];
      setOrganizations(organizations);
      // Now send them to the second API
      await sendLinkedInDetails(organizations);
      await fetchLinkedInDetails();
      setShowOrgModal(true);
    }
  } catch (err) {
    console.error("❌ Fetch org failed:", err.response?.data || err);
  }
};
const exchangeCodeForToken = async (code) => {
  try {
    setConnecting(true);

    const payload = {
      code,
      redirect_uri: "https://ats.bharatpayroll.com/",
    };

    const { data } = await axios.post(
      "https://omnichannelapi.vitelglobal.com/linkedin/api/credentails/",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        withCredentials: true
      }
    );

    console.log("💡 LinkedIn token response:", data);

    // ✅ CORRECT KEY
    const accessToken = data?.results?.access_token;

    if (!accessToken) {
      console.error("❌ Access token not found");
      return;
    }

    // ✅ Store token
    localStorage.setItem("linkedin_access_token", accessToken);
    console.log("✅ LinkedIn token stored:", accessToken);

    // ✅ CALL FETCH ORGANIZATION HERE
    await fetchOrganizationId(accessToken);

  } catch (err) {
    console.error("❌ Exchange code failed:", err.response?.data || err);
  } finally {
    setConnecting(false);

    // clean URL
    window.history.replaceState({}, document.title, window.location.pathname);
  }
};

const [linkedinDetails, setLinkedinDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLinkedInDetails = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(
        "/api/v1/linkedin-details/",
        {
          params: { company_id: companyId },
        }
      );
      console.log("the data",data)

      // Assuming the API returns { linkedin_details: [...] }
      setLinkedinDetails(data.results || []);
      setIsLinkedInConnected(data.is_connected === true);
    } catch (err) {
      console.error("❌ Failed to fetch LinkedIn details:", err.response?.data || err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="content-wrapper" className="admin-dashboard-workspace">
      <div className="MyMarginCls" />
      {permissionsLoaded && requestedTab && !filteredTabs.some(tab => tab.route === requestedTab.route) && (
        <div className="alert alert-warning mx-3" role="alert">You do not have permission to view {requestedTab.label}.</div>
      )}

      <div className="row mx-0">
        <div className="col-lg-12">
          <div className="container-fluid nnn">
            <div className="row">
              <div className="col-12 d-flex flex-wrap align-items-center gap-2 mb-3" id="AdminModule_Tabs">
                <TabView
                  activeIndex={activeIndex}
                  onTabChange={handleTabChange}
                >
                  {filteredTabs.map((tab, index) => (
                    <TabPanel key={index} header={tab.label}>
                      {tab.label === "My Account" && (
                        <div />
                      )}
                    </TabPanel>
                  ))}
                </TabView>

                {/* ================== LINKEDIN BUTTON ================== */}
                <button
                  onClick={handleLinkedInConnect}
                  className="btn btn-primary"
                  disabled={connecting || isLinkedInConnected}
                  style={{
                    backgroundColor: "#0A66C2",
                    border: 0,
                    padding: "6px 16px",
                    fontWeight: "bold",
                    opacity: isLinkedInConnected ? 0.6 : 1,
                    cursor: isLinkedInConnected ? "not-allowed" : "pointer",
                  }}
                >
                  {isLinkedInConnected
                    ? "Connected with LinkedIn"
                    : connecting
                    ? "Connecting..."
                    : "Connect with LinkedIn"}
                </button>

              </div>
              {permissionsLoaded && requestedTab?.label === "Settings" && settingsViewPermission && (
                <div className="col-12"><Settings embedded /></div>
              )}
            </div>
          </div>
        </div>
      </div>
       <Modal show={showOrgModal} onHide={handleCloseOrgModal} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>Organization Details</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {loading ? (
      <p>Loading...</p>
    ) : linkedinDetails.length > 0 ? (
      <Table striped bordered hover>
        <thead>
          <tr>
            <th className="text-center">Organization ID</th>
            <th className="text-center">Organization Name</th>
            {/* <th>Access Token</th> */}
          </tr>
        </thead>
        <tbody>
          {linkedinDetails.map((org, index) => (
            <tr key={index}>
              <td className="text-center">{org.organisation_id}</td>
              <td className="text-center">{org.organisation_name}</td>
              {/* <td style={{ maxWidth: "300px", wordBreak: "break-word" }}>{org.access_token}</td> */}
            </tr>
          ))}
        </tbody>
      </Table>
    ) : (
      <p>No LinkedIn details found.</p>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={handleCloseOrgModal}>
      Close
    </Button>
  </Modal.Footer>
</Modal>


    </section>
  );
};

export default AdminDasboardats;
